// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__nqZJ9","sidebar":"Layout_sidebar__T6D3N","sidebar-sticky":"Layout_sidebar-sticky__mnW2l","sidebar-heading":"Layout_sidebar-heading__f0Oda"};